import { faCopy } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import type React from 'react';

import type { CopyToClipboardProps } from './CopyToClipboard.types';

export const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
  text,
  size = 'small',
  ...iconButtonProps
}) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      enqueueSnackbar('Copied to clipboard', {
        variant: 'success'
      });
    } catch (_error) {
      enqueueSnackbar('Failed to copy to clipboard', {
        variant: 'error'
      });
    }
  };

  return (
    <IconButton
      color="primary"
      size={size}
      onClick={handleCopy}
      {...iconButtonProps}
    >
      <FontAwesomeIcon icon={faCopy} />
    </IconButton>
  );
};

export default CopyToClipboard;
